import { AuthClassification } from './auth.interface';

const AUTH_KEY = 'AUTH_KEY';

export const getToken = () => {
  return localStorage.getItem(AUTH_KEY) || '';
};

export const setToken = (token: string) => {
  localStorage.setItem(AUTH_KEY, token || '');
  setAccessTokenCookie(token);
};

export const setAccessTokenCookie = (token: string) => {
  if (!token) {
    clearAccessTokenCookie();

    return;
  }

  try {
    const { exp } = decodeToken(token);
    const expires = new Date(exp * 1000).toUTCString();

    document.cookie = `authToken=${encodeURIComponent(
      token,
    )}; path=/; secure; samesite=strict; expires=${expires}`;
  } catch {
    // Token is not a valid JWT — skip cookie
  }
};

export const clearAccessTokenCookie = () => {
  document.cookie =
    'authToken=; path=/; secure; samesite=strict; expires=Thu, 01 Jan 1970 00:00:00 GMT';
};

export const decodeToken = (token: string): Record<string, any> => {
  return JSON.parse(window.atob(token.split('.')[1]));
};

export const handleCCPermission = (token: string | null) => {
  if (!token) {
    return;
  }
  const userAuthInfo = decodeToken(token);
  const ccPermissionKey = Object.keys(userAuthInfo).find((key) =>
    key.includes('cc/role'),
  );
  const userRole = ccPermissionKey
    ? userAuthInfo[ccPermissionKey]
    : AuthClassification.NONE;

  return userRole;
};

export const isTokenValid = () => {
  const token = getToken();

  return token && decodeToken(token).exp * 1000 >= Date.now();
};
